module.exports = __webpack_public_path__ + "img/80038730.054c03f4.png";